import { FC } from 'react';

interface IIconProps {
	className?: string;
}

export const VirtualStop: FC<IIconProps> = ({ className }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
			className={className}
		>
			<path
				fill="currentColor"
				d="M12 6a2 2 0 0 1-2-2c0-1.1.9-2 2-2a2 2 0 0 1 2 2 2 2 0 0 1-2 2Zm5-4h2c0 2.7-.93 4.41-2.3 5.5-.5.4-1.1.7-1.7.9V22h-2v-6h-2v6H9V10.1c-.3.1-.5.2-.6.3-.53.41-1.4 1.03-1.4 3.6H5c0-2.06.35-3.78 2.11-5.29A7.97 7.97 0 0 1 12 7c2 0 2.68-.46 3.48-1.06C15.96 5.55 17 4.76 17 2ZM4 16h3v6H4v-6Z"
			/>
		</svg>
	);
};
